import script from "./segmented-survey-company-form.vue?vue&type=script&setup=true&lang=js"
export * from "./segmented-survey-company-form.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__